import React, { useState, useCallback, useRef, useMemo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faExclamationTriangle, faTrashAlt, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import ConfirmContext from '../contexts/ConfirmContext';
import './styles/ConfirmDialog.css';

export function ConfirmProvider({ children }) {
  const [dialog, setDialog] = useState(null);
  const resolveRef = useRef(null);

  const confirm = useCallback(({
    title = 'Confirm',
    message = 'Are you sure?',
    confirmText = 'Confirm',
    cancelText = 'Cancel',
    variant = 'primary',
  } = {}) => {
    return new Promise(resolve => {
      resolveRef.current = resolve;
      setDialog({ title, message, confirmText, cancelText, variant });
    });
  }, []);

  const close = useCallback((result) => {
    resolveRef.current?.(result);
    resolveRef.current = null;
    setDialog(null);
  }, []);

  const value = useMemo(() => ({ confirm }), [confirm]);

  const getVariantIcon = (variant) => {
    if (variant === 'danger') return faTrashAlt;
    if (variant === 'success') return faCheckCircle;
    return faExclamationTriangle;
  };

  return (
    <ConfirmContext.Provider value={value}>
      {children}
      {dialog && (
        <div className="confirm-overlay" onClick={() => close(false)}>
          <div className="confirm-dialog" onClick={(e) => e.stopPropagation()}>
            <div className="confirm-header">
              <div className="confirm-header-left">
                <FontAwesomeIcon
                  icon={getVariantIcon(dialog.variant)}
                  className={`confirm-title-icon confirm-title-icon--${dialog.variant}`}
                />
                <h3 className="confirm-title">{dialog.title}</h3>
              </div>
              <div className="confirm-header-right">
                <button className="confirm-close-btn" onClick={() => close(false)} title="Close">
                  <FontAwesomeIcon icon={faTimes} />
                </button>
              </div>
            </div>
            <div className="confirm-body">
              <p className="confirm-message">{dialog.message}</p>
            </div>
            <div className="confirm-footer">
              <button className="confirm-cancel-btn" onClick={() => close(false)}>
                {dialog.cancelText}
              </button>
              <button
                className={`confirm-action-btn confirm-action-btn--${dialog.variant}`}
                onClick={() => close(true)}
              >
                {dialog.confirmText}
              </button>
            </div>
          </div>
        </div>
      )}
    </ConfirmContext.Provider>
  );
}
